module.exports = __webpack_public_path__ + "img/Cover_HW_25.a9e81c1c.jpg";